const config = {
    token: 'your-craftql-token'
};

export default config;
